define([
    './QuestionSetService',
    './QuestionSetDirective',
    'portalConfig'
], (QuestionSetService, QuestionSetDirective)=> {
    return angular.module('edge.platform.questionsets', ['portal.config'])
        .directive('gwPlQuestionSet', QuestionSetDirective)
        .provider('QuestionSetService', QuestionSetService);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/questionsets/module.js
 **/